import React, { useState } from 'react';
import { Button } from 'antd';
import { I18n } from '@aws-amplify/core';
import Can from '@/components/Can';
import { PlanDetailsModal } from './PlanDetailsModal';

export function PlanDetailsButton() {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	function handleOnClick(): void {
		setIsOpen(true);
	}

	function handleOnCancel(): void {
		setIsOpen(false);
	}

	const isDisabled: boolean = !Can('settings', 'billing');

	return (
		<>
			<PlanDetailsModal open={isOpen} onCancel={handleOnCancel} />
			<Button type="link" size="large" disabled={isDisabled} onClick={handleOnClick}>
				{I18n.get('See more details')}
			</Button>
		</>
	);
}
